module.exports = __webpack_public_path__ + "img/epic23.147ec579.jpg";